import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, num }) => (
  <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.28em] text-[var(--pink-text)]">
    {num && <span className="font-mono-x text-zinc-400">{num}</span>}
    <span className="h-px w-10 bg-neon" />
    <span>{children}</span>
  </div>
);
